<div class="remove-unit-main">
  <div class="top-header w-100 mb-5">
    <div class="col-11">
      <p class="modal-title text-center question ml-3">
        {{ (removeAP ? "REMOVE_ACCESS_POINT" : "REMOVE_UNIT") | translate }}
      </p>
    </div>
    <div class="col-1">
      <img
        src="/assets/svg/ico-cross.svg"
        class="cross-button"
        (click)="closeDialog()"
      />
    </div>
  </div>
  <br />

  <div class="message w-100 h-100 py-5">
    <div class="my-5 mx-4">
      <div
        class="w-100 h-100 d-flex flex-column justify-content-center align-items-center"
      >
        <p class="question text-center">
          {{
            (removeAP
              ? "ARE_YOU_SURE_YOU_WANT_TO_ACCESS_POINT"
              : "ARE_YOU_SURE_YOU_WANT_TO_REMOVE_UNIT") | translate
          }}
        </p>
      </div>
      <div
        class="w-100 h-100 d-flex flex-column justify-content-center align-items-center"
      >
        <p class="message text-center">
          {{
            (removeAP
              ? "BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_AP"
              : "BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO") | translate
          }}
        </p>
      </div>
    </div>
  </div>

  <div class="row my-2">
    <div class="col-12 my-1">
      <button
        class="yes-btn btn btn-danger px-3 w-100"
        type="button"
        tabindex="-1"
        *accessControl="[PageName.Unit, CONSTANTS.DELETE]"
        (click)="deleteItem()"
      >
        {{ 'YES' | translate }}
      </button>
    </div>
  </div>

  <div class="row my-2">
    <div class="col-12 my-1">
      <button
        type="button"
        class="no-button px-5 py-3 mt1 mb-4 w-100"
        (click)="closeDialog()"
      >
        <strong> {{ 'NO' | translate }} </strong>
      </button>
    </div>
  </div>
</div>
